<template>
  <div class="social-media-box">
    <div>
      <h4>登录账号</h4>

<!--      <div>-->
<!--        <h5>登录用户名</h5>-->
<!--        <div>-->
<!--          <el-input :value="userInfo.username" placeholder="用户名" disabled>-->
<!--            <el-button slot="append" type="primary" @click="handleUpdateUsername">修改</el-button>-->
<!--          </el-input>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div>-->
<!--        <h5>登录邮箱</h5>-->
<!--        <div>-->
<!--          <el-input :value="userInfo.email" placeholder="邮箱" disabled>-->
<!--            <el-button slot="append" type="primary" @click="handleUpdateEmail">更换邮箱</el-button>-->
<!--          </el-input>-->
<!--        </div>-->
<!--      </div>-->

      <div>
        <h5>密保手机</h5>
        <div>
          <el-input :value="userInfo.mobile" placeholder="未绑定手机号" disabled>
            <el-button slot="append" type="primary" @click="phoneDialogVisible = true">{{userInfo.mobile ? "更换号码" : "绑定"}}</el-button>
          </el-input>
        </div>
      </div>

      <div>
        <h5>邮箱</h5>
        <div>
          <el-input :value="userInfo.email" placeholder="未绑定邮箱" disabled>
            <el-button slot="append" type="primary" @click="emailDialogVisible = true">{{userInfo.email ? "更换邮箱" : "绑定"}}</el-button>
          </el-input>
        </div>
      </div>

      <div>
        <h5>登录密码</h5>
        <div>
          <el-input type="password" value="******" disabled>
            <el-button slot="append" type="primary" @click.native="pwdDialogVisible = true">修改密码</el-button>
          </el-input>
        </div>
      </div>
    </div>

    <update-mobile :visible.sync="phoneDialogVisible" :form-data="{
        id: userInfo.id,
        mobile: userInfo.mobile
    }" />
    <update-email :visible.sync="emailDialogVisible" :form-data="{
        id: userInfo.id,
        email: userInfo.email
    }" />
    <update-password :visible.sync="pwdDialogVisible" />
  </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import updatePassword from './update-password'
    import updateMobile from './update-mobile'
    import updateEmail from './update-email'

    export default {
        components: {
            updateMobile,
            updateEmail,
            updatePassword
        },
        data() {
            return {
                formData: {},
                phoneDialogVisible: false,
                emailDialogVisible: false,
                pwdDialogVisible: false
            }
        },
        computed: {
            ...mapGetters(['userInfo'])
        }
    }
</script>

<style lang="scss" scoped>
  .social-media-box {
    h4 {
      line-height: 2em;
    }
    h5 {
      line-height: 2em;
      margin-top: 1em;
      &+div{
        margin-top: 0.6em;
      }
    }
    .el-input {
      width: 50%;
      min-width: 200px;
      max-width: 280px;
    }
  }
</style>
